import { object, string } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import SlideThumbnail from '../SlideThumbnail'
import TextSlide from '../TextSlide'

import './styles.scss'

const TextSlideThumbnail = ({
  backgroundImageURL,
  htmlText,
  layout,
  theme = {},
}) => (
  <SlideThumbnail
    className={kuiperClassNames('text-slide-thumbnail')}
    renderHeader={false}
    theme={theme}
  >
    <TextSlide
      backgroundImageURL={backgroundImageURL}
      viewOnlyMode={true}
      layout={layout}
      theme={theme}
      htmlText={htmlText}
    />
  </SlideThumbnail>
)

TextSlideThumbnail.propTypes = {
  backgroundImageURL: string,
  htmlText: string,
  layout: string,
  theme: object,
}

export default TextSlideThumbnail
